// cart-progress-bar.js — tiered progress bar (unified via PBCart)
(function () {
  const drawer =
    document.querySelector('[data-pb-cart-drawer="primary"]') ||
    document.getElementById('UnifiedCartDrawer');
  if (!drawer) return;

  const barHost = document.getElementById('CartProgressBar');
  if (!barHost) return;

  // Left-hand shipping text. Its initial (not-yet-reached) markup is the
  // customizer banner; we cache it so we can restore it when below threshold.
  const shipTextEl = document.getElementById('CartShipText');
  const shipTextDefaultHTML = shipTextEl ? shipTextEl.innerHTML : '';

  // Empty-cart shows the full-width free-shipping banner; active cart shows the
  // compact shipping-text + progress-bar row.
  const bannerEl = document.getElementById('CartFreeShipBanner');
  const shipRowEl = document.getElementById('CartShipRow');

  function isCartEmpty(gqlCart) {
    if (!gqlCart) return true;
    if (Number(gqlCart.totalQuantity || 0) === 0) return true;
    const edges = gqlCart?.lines?.edges || [];
    return edges.length === 0;
  }

  function setEmptyState(empty) {
    // Empty cart → full-width free-shipping banner.
    // Active cart → compact shipping-text + progress-bar row.
    if (bannerEl) bannerEl.hidden = !empty;
    if (shipRowEl) shipRowEl.hidden = empty;
    drawer.classList.toggle('ucd-cart-empty', empty);
  }

  // --- Excluded product IDs (gift cards + memberships) ---
  // Lines with these product IDs are excluded from the tier subtotal
  const EXCLUDED_PRODUCT_IDS = [
    'gid://shopify/Product/4849416896586',  // Gift card
    'gid://shopify/Product/15652866294134', // Membership
    'gid://shopify/Product/15630492238198'  // Membership
  ];

  /**
   * Returns the cart subtotal in cents, excluding gift card lines.
   * Works with the Storefront API GraphQL cart object (lines.edges[].node).
   */
  function subtotalExcludingGiftCards(gqlCart) {
    const edges = gqlCart?.lines?.edges || [];

    if (edges.length === 0) {
      // Fallback: if lines are missing (e.g. cart not yet hydrated),
      // fall back to the full subtotal so the bar still renders.
      return Math.round(parseFloat(gqlCart?.cost?.subtotalAmount?.amount || 0) * 100);
    }

    const totalEuros = edges.reduce((sum, { node: line }) => {
      const productId = line.merchandise?.product?.id || '';
      if (EXCLUDED_PRODUCT_IDS.includes(productId)) return sum;
      return sum + parseFloat(line.cost?.totalAmount?.amount || 0);
    }, 0);

    return Math.round(totalEuros * 100);
  }

  // --- Tiers ---
  function readTiers() {
    const nodes = drawer.querySelectorAll('[data-tier]');
    const tiers = [...nodes].map(n => ({
      id: n.dataset.id,
      threshold: Number(n.dataset.threshold || 0),
      rewardType: n.dataset.rewardType || 'free_product',
      productTitle: n.dataset.productTitle || '',
      productLabel: n.dataset.productLabel || '',
      useRemaining: n.dataset.useRemaining === 'true',
      useReached:   n.dataset.useReached === 'true',
      remainingTpl: n.dataset.remainingLabel || 'Nog {remaining_amount} om te genieten van je {product_title}!',
      reachedTpl:   n.dataset.reachedLabel   || 'Je hebt een {product_title} ontgrendeld.',
      stepLabel: n.dataset.stepLabel || '',
      stepIcon:  n.dataset.stepIcon  || ''
    }))
    .filter(t => !Number.isNaN(t.threshold))
    .sort((a, b) => a.threshold - b.threshold);

    return tiers.slice(0, 5);
  }

  function eur(cents) {
    const v = Math.max(0, Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(v); }
    catch { return '€' + v.toFixed(2).replace('.', ','); }
  }

  // Single checkpoint: prefer the free-shipping tier, else the lowest threshold.
  function pickCheckpoint(tiers) {
    return tiers.find(t => t.rewardType === 'free_shipping') || tiers[0];
  }

  function buildBar(tier) {
    const key = String(tier.threshold);
    if (barHost.dataset.built === key) return;
    barHost.dataset.built = key;

    // Compact track + fill only — no checkpoint dot; the bar fills to 100% at
    // the threshold. Shipping text lives to the left (in the Liquid markup).
    barHost.innerHTML = `
      <div class="ucd-pbar">
        <div class="ucd-pbar__track">
          <div class="ucd-pbar__fill" style="width:0%"></div>
        </div>
      </div>
    `;
  }

  // --- Main update ---
  function update(cartObj) {
    const tiers = readTiers();
    if (!tiers.length) return;

    const tier = pickCheckpoint(tiers);
    if (!tier) return;

    buildBar(tier);

    const fill = barHost.querySelector('.ucd-pbar__fill');

    const euros = (cartObj.total_price || 0) / 100;
    const threshold = tier.threshold;
    const reached = threshold > 0 && euros >= threshold;

    // No checkpoint: the bar fills to 100% at the threshold.
    let fillPercent = threshold > 0 ? (euros / threshold) * 100 : 0;
    fillPercent = Math.min(100, Math.max(0, fillPercent));
    if (fill) fill.style.width = fillPercent + '%';

    // Swap the left text to the customizer "reached" label once the threshold is
    // met; otherwise restore the original free-shipping banner text.
    if (shipTextEl) {
      if (reached) {
        const productTitle = tier.productTitle || tier.productLabel || '';
        const reachedTpl = tier.reachedTpl || 'Je hebt gratis verzending ontgrendeld!';
        shipTextEl.textContent = reachedTpl
          .replace(/\{remaining_amount\}/g, eur(0))
          .replace(/\{product_title\}/g, productTitle);
      } else {
        shipTextEl.innerHTML = shipTextDefaultHTML;
      }
    }
  }

  // --- Hooks ---
  async function refresh() {
    try {
      const gqlCart = await PBCart.refresh();
      const empty = isCartEmpty(gqlCart);
      setEmptyState(empty);

      // Keep the bar visible in both states; it reads 0% when the cart is empty.
      const cart = {
        total_price: empty ? 0 : subtotalExcludingGiftCards(gqlCart)
      };
      update(cart);
    } catch (e) {
      // ignore errors
    }
  }

  

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('pb:cart:updated', e => {
    const gqlCart = e.detail?.cart;
    if (!gqlCart) return;

    const empty = isCartEmpty(gqlCart);
    setEmptyState(empty);

    const cart = {
      total_price: empty ? 0 : subtotalExcludingGiftCards(gqlCart)
    };
    update(cart);
  });
  document.addEventListener('cart:open', refresh);
})();

// ---------- WONDR 5 JAAR — Prize draw teaser ----------
(function () {
  const PRIZE_MIN_QTY = 4;
  const WONDR_PRIZE_ATTRIBUTE = 'wondr_prize_number';

  function updatePrizeTeaser(cart) {
    // Alleen tonen als campagne actief is
    const isTestMode = new URLSearchParams(location.search).get('wondr_test') === '1';
    const isCampaignLive = false; // ← zelfde flag als in pb-cart.js
    if (!isTestMode && !isCampaignLive) {
      document.getElementById('WondrPrizeTeaser')?.remove();
      return;
    }

    const msgEl = document.getElementById('CartProgressMessage');
    if (!msgEl) return;

    const lines = (cart?.lines?.edges || []).map(e => e.node);

    // Eligible quantity (excl. free gifts)
    const eligibleQty = lines
      .filter(line => !line.attributes?.some(a => a.key === '_auto_gift' && a.value === 'true'))
      .reduce((sum, line) => sum + line.quantity, 0);

    // Al een prize getrokken? Dan niets tonen
    const alreadyDrawn = cart?.attributes?.find(a => a.key === WONDR_PRIZE_ATTRIBUTE)?.value;
    if (alreadyDrawn) return;

    const remaining = PRIZE_MIN_QTY - eligibleQty;

    if (remaining > 0) {
      // Aparte div zodat we de bestaande progress message niet overschrijven
      let teaserEl = document.getElementById('WondrPrizeTeaser');
      if (!teaserEl) {
        teaserEl = document.createElement('p');
        teaserEl.id = 'WondrPrizeTeaser';
        teaserEl.className = 'progress-message';
        teaserEl.style.cssText = 'margin-top:4px;';
        msgEl.parentNode.insertBefore(teaserEl, msgEl.nextSibling);
      }
      teaserEl.textContent = `🎁 Nog ${remaining} product${remaining > 1 ? 'en' : ''} om te mogen draaien aan het rad na betaling!`;
    } else {
      // Drempel bereikt maar nog niet naar checkout gegaan
      let teaserEl = document.getElementById('WondrPrizeTeaser');
      if (!teaserEl) {
        teaserEl = document.createElement('p');
        teaserEl.id = 'WondrPrizeTeaser';
        teaserEl.className = 'progress-message';
        teaserEl.style.cssText = 'margin-top:4px;';
        msgEl.parentNode.insertBefore(teaserEl, msgEl.nextSibling);
      }
      teaserEl.textContent = `🎉 Voltooi je bestelling om aan het rad te draaien!`;
    }
  }

  document.addEventListener('pb:cart:updated', (e) => {
    updatePrizeTeaser(e.detail?.cart);
  });
})();